import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Notifications_ModuleContextService } from './Notifications.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Notifications_transaction_report_ComponentContextService {
  private readonly moduleContext: Notifications_ModuleContextService;

  constructor(moduleContext: Notifications_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'transaction_report',
      type: ComponentType.report
    }
  }
}